import Button from "../../Button";
import Box from "@mui/material/Box";
import { useVideo } from "react-use";
import Select from "@mui/material/Select";
import Slider from "@mui/material/Slider";
import constants from "../../../constants";
import { FormControl } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { Editor } from "@tinymce/tinymce-react";
import IconButton from "@mui/material/IconButton";
import { getDataFromStorage } from "../../../util";
import BackSvgIcon from "../../../Svg/BackSvgIcon";
import GridViewSvg from "../../../Svg/GridViewSvg";
import ListViewSvg from "../../../Svg/ListViewSvg";
import BookmarkSvg from "../../../Svg/BookmarkSvg";
import RightSvgIcon from "../../../Svg/RightSvgIcon";
import Checkbox from "../../CommonComponents/Checkbox";
import BookmarkedSvg from "../../../Svg/BookmarkedSvg";
import AlertContext from "../../../context/AlertContext";
import WobackCloseSvg from "../../../Svg/WobackCloseSvg";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import CircularProgress from "@mui/material/CircularProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StudentTestBackDropCounter from "./StudentTestBackDropCounter";
import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import StudentTestBodyPageSingleView from "./StudentTestBodyPageSingleView";
import { StudentTestPageContext } from "../../../context/StudentTestPageContext";
import StudentTestPageHooks from "../../../Hooks/StudentTestPage/StudentTestPageHooks";
import StudentTestAdminHooks from "../../../Hooks/StudentTestPage/StudentTestAdminHooks";
import StudentTestBodyPageHooks from "../../../Hooks/StudentTestPage/StudentTestBodyPageHooks";
import StudentTestBodyPageSingleViewHooks from "../../../Hooks/StudentTestPage/StudentTestBodyPageSingleViewHooks";

import {
  faForwardStep,
  faBackwardStep,
} from "@fortawesome/free-solid-svg-icons";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import * as axiosPublic from "../../../api/axios";
import Banner from "../../Admin/QuestionEntry/CodingQuestionEntry/Banner";

const parse = require("html-react-parser");

const PrettoSlider = styled(Slider)({
  color: "#F55533",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-rail": {
    opacity: 1,
    backgroundColor: "#EAECF0",
  },
  "& .MuiSlider-thumb": {
    width: 24,
    height: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    width: 32,
    padding: 0,
    height: 32,
    fontSize: 12,
    lineHeight: 1.2,
    background: "unset",
    backgroundColor: "#101828",
    borderRadius: "50% 50% 50% 0",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

/* get the video duration  */

const VideoPlayer = ({ videoSrc }) => {
  console.log("videosrc",videoSrc);
  
  const {getPreSignedUrl} =useS3FileManagement();

  const [videoDuration, setVideoDuration] = useState(0);
  const hasFetchedDuration = useRef(false); // Prevent duplicate duration fetching
  const [videoMetadata,setVideoMetadata] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);

  const videoRef = useRef(null);

  useEffect(()=>{
    const loadVideo = async () => {
       let url;
      if(videoSrc){
        if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
          url = { url: process.env.REACT_APP_NODE_API + videoSrc };
        } else {
          const { url:signedUrl } = await getPreSignedUrl(videoSrc,undefined,
            videoSrc?.split(".")?.pop(),
            "GET");
          // const result= await axiosPublic.default({
          //       method: "GET",
          //       url: signedUrl,
          //       responseType: "arraybuffer",
          // })
      
          // // const uint8Array = await streamToUint8Array(result.data);
          // const blob = new Blob([result.data], { type: "video/mp4" });
      
          // url = URL.createObjectURL(blob);
          url = signedUrl
        }
      }
      setVideoMetadata(url);
    };

    loadVideo();
  },[videoSrc])
  
    const fetchVideoData = async (path) => {
      try {
        let url;
  
        if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
          url = { url: process.env.REACT_APP_NODE_API + path };
        } else {
          // const result = await getS3Object(
          //   path,
          //   undefined,
          //   "arraybuffer"
          // );
          const {url: signedUrl} = await getPreSignedUrl(
            path,
            undefined,
            path?.split(".")?.pop(),
            "GET"
          );
  
          // const result= await axiosPublic.default({
          //   method: "GET",
          //   url: signedUrl,
          //   responseType: "arraybuffer",
          // })
  
          // const uint8Array = await streamToUint8Array(result.data);
          // const blob = new Blob([result.data], { type: "video/mp4" });
  
          // url = URL.createObjectURL(blob);
          url = signedUrl
         
        }
  
         setVideoMetadata(url);
      } catch (error) {
        console.error("Error fetching Video data:", error);
      }
    };
  // const [video, state, controls, ref] = useVideo(
  //   <video src={videoMetadata || ""}  controls preload="metadata"  />
  // );
  console.log("videoMetadata",videoMetadata);
  
  // useEffect(() => {
  //   if (!videoMetadata || hasFetchedDuration.current) return;

  //   hasFetchedDuration.current = true; // Ensure duration is only fetched once

  //   const getDuration = async () => {
  //     try {
  //       const duration = await fetchVideoDuration(videoMetadata);
  //       setVideoDuration(duration);
  //     } catch (err) {
  //       console.error("Error fetching video duration:", err);
  //     }
  //   };

  //   getDuration();
  // }, [videoMetadata]);

  // const fetchVideoDuration = (videoSrc) => {
  //   return new Promise((resolve, reject) => {
  //     const video = document.createElement("video");

  //     video.preload = "metadata";
  //     video.crossOrigin = "anonymous";
  //     video.src = videoSrc;

  //     video.onloadedmetadata = () => {
  //       if (video.duration === Infinity || video.duration <= 0) {
  //         video.currentTime = 9999999; // Seek to last frame
  //         video.ontimeupdate = () => {
  //           video.ontimeupdate = null;
  //           resolve(video.duration.toFixed(2));
  //         };
  //       } else {
  //         resolve(video.duration.toFixed(2));
  //       }
  //     };

  //     video.onerror = () => reject("Failed to load metadata");
  //   });
  // }; // Depend on videoSrc so it runs when a new video is loaded

  const formatTime = (time) => {
    if (!time || isNaN(time) || time === Infinity) return "0:00";

    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);

    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  if(!videoSrc) return null
  
  if (!videoMetadata) return    <div className="video_loading">
                                                      <CircularProgress
                                                        className="progresscircle-video-box-circle"
                                                        thickness={5}
                                                      />
                                                    </div>;

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <video
        ref={videoRef}
        src={videoMetadata || ""}
        controls
        preload="metadata"
        width="100%"
        onLoadedMetadata={(e) =>{
          console.log(e.target.duration);
          setVideoDuration(e.target.duration)
        }
        }
        onTimeUpdate={(e) =>{
          console.log(e.target.currentTime);
          setCurrentTime(e.target.currentTime)
        }
        }
        onCanPlay={(e) => {
          if (!videoDuration || isNaN(videoDuration)) {
            setVideoDuration(e.target.duration);
          }
        }}
      />
      {/* Show current time & total duration */}

      <div
        style={{
          right: "10px",
          color: "white",
          top: "10px",
          fontSize: "14px",
          padding: "5px 10px",
          borderRadius: "5px",
          position: "absolute",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        {formatTime(currentTime)} / {formatTime(videoDuration)}
      </div>
      <div
        style={{
          left: "95px",
          width: "50px",
          bottom: "40px",
          color: "white",
          display: "flex",
          fontSize: "14px",
          padding: "2px 10px",
          borderRadius: "5px",
          position: "absolute",
          justifyContent: "space-between",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <span style={{cursor:"pointer"}}>
          <FontAwesomeIcon
            icon={faBackwardStep}
            onClick={() => (videoRef.current.currentTime -= 5)}
          />
        </span>
        <span style={{cursor:"pointer"}}>
          <FontAwesomeIcon
            icon={faForwardStep}
            onClick={() => (videoRef.current.currentTime += 5)}
          />
        </span>
      </div>
    </div>
  );
};

export default function StudentTestBodyPage() {
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const Alert = useContext(AlertContext);
  // const { setIsLoaded } = useContext(AlertContext);
  // const [IsLoad, setIsLoad] = useState(false); //loading

  const StudentTestPageCxt = useContext(StudentTestPageContext);
  const StudentTestPageHks = StudentTestPageHooks();
  const StudentTestAdminHks = StudentTestAdminHooks();
  const StudentTestBodyPageHks = StudentTestBodyPageHooks();
  const StudentTestBodyPageSingleViewHks = StudentTestBodyPageSingleViewHooks();

  useEffect(() => {
    StudentTestBodyPageSingleViewHks.setAnswers(Alert.answerRef.current);
  }, [Alert.answerRef.current]);

  useEffect(() => {
    return () => {
      if (StudentTestPageCxt.editorRef.current) {
        StudentTestPageCxt.editorRef.current.destroy();
      }
    };
  }, []);

  /* each qn timelimit */

  useEffect(() => {
    if (!StudentTestPageCxt.showtransition) {
      const handleqnTimeLimit = setInterval(() => {
        if (StudentTestPageCxt.vdoQnTimelimit === 0) {
          StudentTestBodyPageHks.handleSingleVdoQnSubmit();
          clearInterval(handleqnTimeLimit);
        } else {
          StudentTestPageCxt.setVdoQnTimelimit((seconds) => seconds - 1);
        }
      }, 1000);

      return () => {
        clearInterval(handleqnTimeLimit);
      };
    }
  }, [StudentTestPageCxt.vdoQnTimelimit, StudentTestPageCxt.showtransition]);

  /* dynamic font change */

  useEffect(() => {
    if (StudentTestPageCxt.showtransition) {
      const element = StudentTestPageCxt.textRef.current;
      const container = element?.parentElement;
      const containerWidth = container?.clientWidth;
      const minFontSize = 18;
      const maxFontSize = 50;
      const step = 1.5;

      if (element && containerWidth) {
        let currentFontSize = maxFontSize;
        element.style.fontSize = `${currentFontSize}px`;

        // Reduce font size until the text fits within the container

        while (
          element.scrollWidth > containerWidth &&
          currentFontSize > minFontSize
        ) {
          currentFontSize -= step;
          element.style.fontSize = `${currentFontSize}px`;
        }

        let height = element.scrollHeight;

        while (height >= 500 && currentFontSize > minFontSize) {
          currentFontSize -= step;
          height -= 30;
          element.style.fontSize = `${currentFontSize}px`;
        }

        // Ensure the font size is not less than the minimum font size
        if (currentFontSize < minFontSize) {
          currentFontSize = minFontSize;
        }
      }
    }
  }, [StudentTestPageCxt.showtransition]);

  const evaluateTest = (data) => {
    Alert.setIsLoaded(true);

    const payload = {
      testid: data.testid,
      lpid: data.lpid,
      learnerid: data.learnerid,
      lpconfigid: data.lpconfigid,
      videotest: Alert.comingObj.videoqn === 1,
    };

    axios
      .post(
        "node/learner/test/ai/score", // API endpoint
        JSON.stringify(payload), // Payload
        {
          timeout: 2000000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then((res) => {
        Alert.setIsLoaded(false);
        StudentTestAdminHks.handleMcq(Alert.mcqAndDesTestAndLpId);
      })
      .catch((error) => {
        Alert.setIsLoaded(false);
        StudentTestAdminHks.handleMcq(Alert.mcqAndDesTestAndLpId);
      });
  };

  
  const hasAnyNewVersion = useMemo(()=> StudentTestPageCxt.fSections.some(section =>
    section.questions.some(q => q.hasNewVersion === 1 && !q.isFixedQn)
  ),[StudentTestPageCxt.fSections]);
  const newVersionQuestions = useMemo(()=>StudentTestPageCxt.fSections.flatMap(section =>
    section.questions.filter(q => q.hasNewVersion === 1 && !q.isFixedQn)
  ),[StudentTestPageCxt.fSections]);

  console.log("StudentTestPageCxt.selsec---",StudentTestPageCxt.selSec);
  
  return (
    <>
      <div className="component-one">
        {StudentTestPageCxt.showtransition &&
          StudentTestPageCxt.showTimer &&
          ((!Alert.isAdmin &&
            Alert.mcqAndDesTestAndLpId.status ===
              constants.PROGRESS_STATUS.IN_PROGRESS) ||
            (!Alert.isAdmin &&
              Alert.mcqAndDesTestAndLpId.status ===
                constants.PROGRESS_STATUS.UNLOCKED) ||
            (!Alert.isAdmin &&
              Alert.mcqAndDesTestAndLpId.status ===
                constants.PROGRESS_STATUS.QN_CONTINUE) ||
            (!Alert.isAdmin &&
              (Alert.mcqAndDesTestAndLpId.status ===
                constants.PROGRESS_STATUS.REATTEMPT || Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION))) &&
          Alert.comingObj.videoqn === 1 && (
            <StudentTestBackDropCounter
              setShowTimer={StudentTestPageCxt.setShowTimer}
              setshowtransition={StudentTestPageCxt.setshowtransition}
            />
          )}
      </div>
      <div className="commontest-mainpage-div">
        {Alert.mcqAndDesTestAndLpId.status ===
          constants.PROGRESS_STATUS.EVALUATED ||
        Alert.mcqAndDesTestAndLpId.status ===
          constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
        Alert.mcqAndDesTestAndLpId.status ===
          constants.PROGRESS_STATUS.PARTIAL_EVALUATED ||
        (Alert.isAdmin &&
          Alert.mcqAndDesTestAndLpId.status ===
            constants.PROGRESS_STATUS.IN_PROGRESS) ||
        (Alert.isAdmin &&
          Alert.mcqAndDesTestAndLpId.status ===
            constants.PROGRESS_STATUS.QN_CONTINUE) ||
        (Alert.isAdmin &&
          (Alert.mcqAndDesTestAndLpId.status ===
            constants.PROGRESS_STATUS.REATTEMPT || Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION)) ||
        Alert.mcqAndDesTestAndLpId.testmode === constants.MODE.PRACTICE_MODE ? (
          <div className="commontest-mainpage-header"> 
            <div className="commontest-mainpage-header-change-section">
              <div className="commontest-mainpage-header-back-btn-dropdown">
                <div>
                  {(Alert.isAdmin ||
                    [constants.PROGRESS_STATUS.EVALUATED, constants.PROGRESS_STATUS.TO_BE_EVALUATED].includes(Alert.mcqAndDesTestAndLpId.status) )&&
                     <BackSvgIcon
                        component="codingProblem"
                        onClick={StudentTestBodyPageHks.backToHomePage}
                    />
                  }
                </div>
                 <FormControl className="header-change-section-form">
                  <Select
                    labelId="learnerSelectLabel"
                    value={StudentTestPageCxt.selSec}
                    className="header-change-section-select"
                    onChange={StudentTestBodyPageHks.handleSecChange}
                  >
                    <MenuItem value={"all"} key={"selectall"}>
                      {"All"}
                    </MenuItem>

                    {Alert.hasOwnProperty("comingObj") &&
                      Alert.comingObj.hasOwnProperty("sections") &&
                      Alert.comingObj.sections.map((sec, ind) => (
                        <MenuItem
                          className="header-change-section-menuitem"
                          value={ind}
                          key={sec.sectionname + "" + ind}
                        >
                          {sec.sectionname}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            {(Alert.isAdmin ||
              StudentTestPageCxt.isTrainer ||
              (StudentTestPageCxt.isLearner &&
                StudentTestPageCxt.viewTest ===
                  constants.DISPLAY_TEST_RESULT.ALL) ||
              Alert.backupTestData.testmode === constants.MODE.PRACTICE_MODE) &&
              (Alert.backupTestData.sections[0].questions[0]?.libtypeid ===
                constants.libTypeIds.SAQ ||
                Alert.backupTestData.sections[0].questions[0]?.libtypeid ===
                  constants.libTypeIds.LAQ ||
                  Alert.backupTestData.sections[0].questions[0]?.libtypeid ===
                  constants.libTypeIds.CODING_SNIPPET ||
                Alert.backupTestData.sections[0].questions[0]?.libtypeid ===
                  constants.libTypeIds.MCQ_SINGLE ||
                Alert.backupTestData.sections[0].questions[0]?.libtypeid ===
                  constants.libTypeIds.MCQ_MULTI) && (
                <>
                  {Alert.isAdmin && hasAnyNewVersion ?
                    <div style={{alignSelf:"center"}}>
                      <Banner text={<>{newVersionQuestions.length} question{newVersionQuestions.length===1?"":"s"} has a newer version available</>}/>
                    </div> 
                  :null}
                  <div className="Show-answer-div">
                    <Checkbox
                      text={"Show explanation"}
                      checked={StudentTestPageCxt.showSaqLaqAns}
                      onChange={StudentTestBodyPageHks.showAnswer}
                    />
                  </div>
                </>
              )}

            {(Alert.isAdmin || StudentTestPageCxt.isTrainer) &&
              // Alert.backupTestData.testmode === constants.MODE.PRACTICE_MODE)
              Alert.comingObj.videoqn === 1 && (
                <div className="Show-answer-div">
                  <Checkbox
                    text={"Show Text"}
                    checked={StudentTestPageCxt.showTranscript}
                    onChange={StudentTestBodyPageHks.showTranscriptFunc}
                  />
                </div>
              )}
            {(Alert.isAdmin || StudentTestPageCxt.isTrainer) &&
              (Alert.mcqAndDesTestAndLpId.status ===
                constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
                Alert.mcqAndDesTestAndLpId.status ===
                  constants.PROGRESS_STATUS.PARTIAL_EVALUATED) && (
                // Alert.backupTestData.testmode === constants.MODE.PRACTICE_MODE ||
                // Alert.comingObj.videoqn === 1
                <div className="Show-answer-div evaluate">
                  <Button
                    size="sm"
                    // onClick={() =>
                    //   StudentTestAdminHks.handleMcq(Alert.mcqAndDesTestAndLpId)
                    // }
                    onClick={() => evaluateTest(Alert.mcqAndDesTestAndLpId)}
                    hierarchy={{
                      type: "primary",
                      buttonText: "Evaluate",
                    }}
                  />
                </div>
              )}
          </div>
        ) : (
          <div className="commontest-mainpage-header">
            <div className="commontest-mainpage-header-section">
              <div className="commontest-mainpage-header-section-title">
                Section:
              </div>
              <div className="commontest-mainpage-header-section-name">
                {Alert.comingObj.videoqn !== 1
                  ? Alert.secObj?.sectionname
                  : StudentTestBodyPageHks.getSectionName(
                      Alert.videoQn.current?.filter((data) => data?.selected)[0]
                        ?.id
                    )}
              </div>
              {Alert.comingObj.videoqn === 1 && (
                <>
                  <div className="commontest-mainpage-header-section-title">
                    Question No:
                  </div>
                  <div className="commontest-mainpage-header-section-name">
                    {StudentTestBodyPageHks.getQuestionNo(
                      Alert.videoQn.current?.filter((data) => data?.selected)[0]
                        ?.id
                    )}
                  </div>
                </>
              )}
            </div>
            {Alert.comingObj.videoqn !== 1 &&
              Alert.comingObj.listview === 1 &&
              Alert.comingObj.testmode !== constants.MODE.PRACTICE_MODE && (
                <div className="commontest-mainpage-header-test-view-mode">
                  <div className="commontest-mainpage-header-test-view-mode-gridbtn">
                    <IconButton
                      onClick={() =>
                        StudentTestBodyPageHks.changeQuestionVisible("single")
                      }
                    >
                      <GridViewSvg />
                    </IconButton>
                  </div>
                  <div className="commontest-mainpage-header-test-view-mode-listbtn">
                    <IconButton
                      onClick={() =>
                        StudentTestBodyPageHks.changeQuestionVisible("multiple")
                      }
                    >
                      <ListViewSvg />
                    </IconButton>
                  </div>
                </div>
              )}
            {Alert.comingObj.videoqn === 1 && (
              <div className="video-qn-timer-div">
                <div className="video-qn-timer-label">Time Left:</div>
                <div className="video-qn-timer">
                  <span>
                    {Math.floor(
                      (StudentTestPageCxt.vdoQnTimelimit % 3600) / 60
                    ).toString().length === 1
                      ? "0" +
                        Math.floor(
                          (StudentTestPageCxt.vdoQnTimelimit % 3600) / 60
                        )
                      : Math.floor(
                          (StudentTestPageCxt.vdoQnTimelimit % 3600) / 60
                        )}
                  </span>
                  {" : "}
                  <span>
                    {Math.floor(
                      (StudentTestPageCxt.vdoQnTimelimit % 3600) % 60
                    ).toString().length === 1
                      ? "0" +
                        Math.floor(
                          (StudentTestPageCxt.vdoQnTimelimit % 3600) % 60
                        )
                      : Math.floor(
                          (StudentTestPageCxt.vdoQnTimelimit % 3600) % 60
                        )}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
        <div
          className={`commontest-mainpage-body${
            !Alert.isAdmin &&
            Alert.comingObj.videoqn === 1 &&
            Alert.mcqAndDesTestAndLpId.status !==
              constants.PROGRESS_STATUS.EVALUATED &&
            Alert.mcqAndDesTestAndLpId.status !==
              constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
            Alert.mcqAndDesTestAndLpId.status !==
              constants.PROGRESS_STATUS.PARTIAL_EVALUATED
              ? "-videoqn"
              : ""
          }`}
        >
          {Alert.mcqAndDesTestAndLpId.status !==
            constants.PROGRESS_STATUS.EVALUATED &&
          Alert.questionContainerSingle ? (
            <StudentTestBodyPageSingleView />
          ) : (
            <div className={"commontest-mainpage-multiple-question-options"}>
              <div className="commontest-mainpage-multiple-question-container">
                {Alert.hasOwnProperty("comingObj") &&
                  Alert.comingObj.hasOwnProperty("sections") &&
                  (StudentTestPageCxt.selSec === "all" ||
                    (StudentTestPageCxt.sectionObj !== null &&
                      typeof StudentTestPageCxt.sectionObj !== "undefined" &&
                      Object.keys(StudentTestPageCxt.sectionObj).length > 0 &&
                      StudentTestPageCxt.sectionObj.hasOwnProperty(
                        "questions"
                      ))) && (
                    <>
                      {
                        <div className="commontest-mainpage-multiple-question-container-loop">
                          {StudentTestPageCxt.fSections.map((fsec, fsecind) => (
                            <div className="commontest-mainpage-multiple-question-container-block" key={fsec.sectionid}>
                              {(Alert.mcqAndDesTestAndLpId.status ===
                                constants.PROGRESS_STATUS.EVALUATED ||
                                Alert.mcqAndDesTestAndLpId.status ===
                                  constants.PROGRESS_STATUS.IN_PROGRESS ||
                                Alert.mcqAndDesTestAndLpId.status ===
                                  constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
                                Alert.mcqAndDesTestAndLpId.status ===
                                  constants.PROGRESS_STATUS.PARTIAL_EVALUATED ||
                                Alert.mcqAndDesTestAndLpId.status ===
                                  constants.PROGRESS_STATUS.QN_CONTINUE) &&
                              StudentTestPageCxt.selSec === "all" &&
                              fsec.questions.length > 0 ? (
                                <div className="testContainerChildLeftHeaderSectionTitle2">
                                  <span className="testContainerChildLeftHeaderSectionTitleLabel">
                                    Section :&nbsp;{" "}
                                  </span>{" "}
                                  <span className="testContainerChildLeftHeaderSectionTitleName">
                                    {fsec.sectionname}
                                  </span>
                                  <span className="singleViewQuestionBoxTitleMarks">
                                    {" ( " +
                                      StudentTestPageHks.getSectionTotal(fsec) +
                                      " Marks )"}
                                  </span>
                                </div>
                              ) : null}
                              {fsec.questions.map((questionobj, queindex) => (
                                <Fragment key={questionobj.id}>
                                  <div
                                    className="commontest-mainpage-multiple-question-box"
                                    id={
                                      "que" +
                                      (Alert.secInd === "all"
                                        ? 0
                                        : Alert.secInd) +
                                      queindex
                                    }
                                  >
                                    <>
                                      <div className="commontest-mainpage-multiple-question-box-title">
                                        {questionobj.review === -1 && (
                                          <IconButton
                                            className="commontest-mainpage-multiple-question-title-reviewlater"
                                            onClick={() =>
                                              StudentTestBodyPageSingleViewHks.reviewLater(
                                                "multi",
                                                "noreview",
                                                queindex
                                              )
                                            }
                                          >
                                            <BookmarkSvg />
                                          </IconButton>
                                        )}
                                        {questionobj.review === 0 && (
                                          <IconButton
                                            className="commontest-mainpage-multiple-question-title-reviewlater"
                                            onClick={() =>
                                              StudentTestBodyPageSingleViewHks.reviewLater(
                                                "multi",
                                                "review",
                                                queindex
                                              )
                                            }
                                          >
                                            <BookmarkedSvg />
                                          </IconButton>
                                        )}

                                        <div className="commontest-mainpage-single-question-title-qnno">
                                          {queindex + 1}.
                                        </div>
                                        <div className="commontest-mainpage-single-question-title-qnname">
                                          {questionobj.name}
                                        </div>

                                        <div className="commontest-mainpage-single-question-title-mark">
                                          {getDataFromStorage("role") ===
                                            "learner" &&
                                            `(${
                                              StudentTestPageCxt.isLearner &&
                                              StudentTestPageCxt.viewTest ===
                                                constants.DISPLAY_TEST_RESULT
                                                  .ALL &&
                                              Alert.testMode ===
                                                constants.MODE.TEST_MODE &&
                                              Alert.mcqAndDesTestAndLpId
                                                ?.status ===
                                                constants.PROGRESS_STATUS
                                                  .EVALUATED
                                                ? `${
                                                    questionobj.actualscore ?? 0
                                                  }/`
                                                : ""
                                            }${questionobj.targetscore} Marks)`}
                                        </div>
                                      </div>
                                      <div className="commontest-mainpage-single-question-option-detail-box">
                                        {questionobj.hasOwnProperty(
                                          "description"
                                        ) &&
                                          questionobj.description != null &&
                                          questionobj.description.length >
                                            0 && (
                                            <div className="multiQuestionContainerDescription">
                                              <br />
                                              {parse(questionobj.description)}
                                            </div>
                                          )}

                                        {questionobj.links.length > 0 ? (
                                          <div className="singleViewQuestionBoxTitleQuestionLinks">
                                            {questionobj.links.map((link) => (
                                              <span className="questionLinks" key={
                                                    link +
                                                    "" +
                                                    StudentTestPageCxt.secIndex
                                                  }>
                                                <img
                                                  width="400"
                                                  height="400"
                                                  alt="userImage"
                                                  key={
                                                    link +
                                                    "" +
                                                    StudentTestPageCxt.secIndex
                                                  }
                                                  src={
                                                    process.env
                                                      .REACT_APP_DEPLOYMENT !==
                                                    "AWS"
                                                      ? process.env
                                                          .REACT_APP_NODE_API +
                                                        link.link
                                                      : link.link
                                                  }
                                                />
                                              </span>
                                            ))}
                                          </div>
                                        ) : null}
                                        <div className="commontest-mainpage-single-question-option-details-div">
                                          {questionobj.libtypeid ===
                                            constants.libTypeIds.SAQ ||
                                          questionobj.libtypeid ===
                                            constants.libTypeIds.LAQ ||
                                          questionobj.libtypeid ===
                                            constants.libTypeIds.CODING_SNIPPET ? (
                                            <div
                                              className="text-area-AnswerDiv"
                                              key={
                                                questionobj.libtypeid +
                                                questionobj.id
                                              }
                                            >
                                              <div
                                                className="desInputWrapper"
                                                data-required={
                                                  Alert.comingObj.videoqn !== 1
                                                    ? Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .UNLOCKED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .REATTEMPT ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .QN_CONTINUE
                                                      ? questionobj.libtypeid ===
                                                        constants.libTypeIds.SAQ || +questionobj.libtypeid === constants.libTypeIds.CODING_SNIPPET
                                                        ? 1024 -
                                                          (Alert.isAdmin
                                                            ? questionobj.answer !=
                                                              null
                                                              ? questionobj
                                                                  .answer.length
                                                              : 0
                                                            : StudentTestBodyPageSingleViewHks
                                                                .answers[
                                                                questionobj.id
                                                              ]?.length) +
                                                          " characters left"
                                                        : 10000 -
                                                          (Alert.isAdmin
                                                            ? questionobj.answer !=
                                                              null
                                                              ? questionobj
                                                                  .answer.length
                                                              : 0
                                                            : StudentTestBodyPageSingleViewHks
                                                                .answers[
                                                                questionobj.id
                                                              ]?.length) +
                                                          " characters left"
                                                      : questionobj.libtypeid ===
                                                        constants.libTypeIds.SAQ || +questionobj.libtypeid === constants.libTypeIds.CODING_SNIPPET
                                                      ? 1024 -
                                                        (Alert.isAdmin
                                                          ? questionobj.answer !=
                                                            null
                                                            ? questionobj.answer
                                                                .length
                                                            : 0
                                                          : questionobj.answer
                                                              ?.length) +
                                                        " characters left"
                                                      : 10000 -
                                                        (Alert.isAdmin
                                                          ? questionobj.answer !=
                                                            null
                                                            ? questionobj.answer
                                                                .length
                                                            : 0
                                                          : questionobj.answer
                                                              ?.length) +
                                                        " characters left"
                                                    : ""
                                                }
                                              >
                                                {StudentTestPageCxt.errorMessage &&
                                                  questionobj.id ===
                                                    StudentTestPageCxt.questionIdOffError && (
                                                    <label
                                                      style={{
                                                        color: "red",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      only numbers and decimals
                                                      are allowed
                                                    </label>
                                                  )}
                                                {Alert.comingObj.videoqn ===
                                                1 ? (
                                                  /* questionobj.answer !== "" && questionobj.answer !== null && questionobj.answer !== undefined */
                                                 
                                                    <>
                                                      {/* <video
                                                      className="videoqn-admin-answer"
                                                      controls
                                                      controlsList="nodownload"
                                                      src={questionobj.answer}
                                                    /> */}
                                                      <VideoPlayer
                                                        videoSrc={
                                                          questionobj.answer
                                                        }
                                                      />
                                                    </>
                                                 
                                                 
                                                ) : (
                                                  <TextareaAutosize
                                                    minRows={7}
                                                    id={questionobj.id}
                                                    key={questionobj.id}
                                                    className="textareaAnswer"
                                                    onCut={
                                                      StudentTestBodyPageSingleViewHks.handleCPC
                                                    }
                                                    onCopy={
                                                      StudentTestBodyPageSingleViewHks.handleCPC
                                                    }
                                                    onPaste={
                                                      StudentTestBodyPageSingleViewHks.handleCPC
                                                    }
                                                    oncontextmenu={
                                                      StudentTestBodyPageSingleViewHks.handleCPC
                                                    }
                                                    name={
                                                      questionobj.id +
                                                      "" +
                                                      StudentTestPageCxt
                                                        .sectionObj.sectionid
                                                    }
                                                    value={
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .TO_BE_EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .PARTIAL_EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .IN_PROGRESS ||
                                                      (Alert.isAdmin &&
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status ===
                                                          constants
                                                            .PROGRESS_STATUS
                                                            .QN_CONTINUE)
                                                        ? questionobj.answer
                                                        : StudentTestBodyPageSingleViewHks
                                                            .answers[
                                                            questionobj.id
                                                          ]
                                                    }
                                                    disabled={
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .TO_BE_EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .PARTIAL_EVALUATED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .IN_PROGRESS ||
                                                      (Alert.isAdmin &&
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status ===
                                                          constants
                                                            .PROGRESS_STATUS
                                                            .QN_CONTINUE)
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) => {
                                                      StudentTestBodyPageSingleViewHks.collectAnswers(
                                                        questionobj.id,
                                                        e.target.value,
                                                        questionobj.libtypeid,
                                                        StudentTestPageCxt.secIndex,
                                                        queindex,
                                                        questionobj?.datatype
                                                      );
                                                    }}
                                                    style={{
                                                      width: "100%",
                                                      resize: "none",
                                                      // minWidth: "57vW",
                                                      borderRadius: "5px",
                                                      marginBottom: "10px",
                                                      border:
                                                        StudentTestPageCxt.errorMessage &&
                                                        questionobj.id ===
                                                          StudentTestPageCxt.questionIdOffError
                                                          ? "1px solid red"
                                                          : Alert
                                                              .mcqAndDesTestAndLpId
                                                              .status ===
                                                              constants
                                                                .PROGRESS_STATUS
                                                                .UNLOCKED ||
                                                            Alert
                                                              .mcqAndDesTestAndLpId
                                                              .status ===
                                                              constants
                                                                .PROGRESS_STATUS
                                                                .REATTEMPT ||
                                                            Alert
                                                              .mcqAndDesTestAndLpId
                                                              .status ===
                                                              constants
                                                                .PROGRESS_STATUS
                                                                .QN_CONTINUE
                                                          ? StudentTestBodyPageSingleViewHks
                                                              .answers[
                                                              questionobj.id
                                                            ]?.length === 0
                                                            ? "1px solid rgba(55, 55, 57, 0.2)"
                                                            : "1px solid #D0D5DD"
                                                          : questionobj.answer
                                                              ?.length === 0
                                                          ? "1px solid rgba(55, 55, 57, 0.2)"
                                                          : "1px solid #D0D5DD",
                                                    }}
                                                    maxLength={
                                                      questionobj.libtypeid ===
                                                      constants.libTypeIds.SAQ  || +questionobj.libtypeid === constants.libTypeIds.CODING_SNIPPET
                                                        ? 1024
                                                        : 10000
                                                    }
                                                  />
                                                )}
                                              </div>

                                              {StudentTestPageCxt.showSaqLaqAns && (
                                                <div className="desc-admin-answer-div">
                                                  <div className="desc-admin-answer-label-div">
                                                    Explanation
                                                  </div>
                                                  <textarea
                                                    rows={5}
                                                    disabled={true}
                                                    id={
                                                      questionobj.id +
                                                      "showanswer"
                                                    }
                                                    key={
                                                      questionobj.id +
                                                      "showanswer"
                                                    }
                                                    className="desc-admin-answer"
                                                    name={
                                                      questionobj.id +
                                                      "" +
                                                      StudentTestPageCxt
                                                        .sectionObj.sectionid +
                                                      "showanswer"
                                                    }
                                                    value={questionobj?.options
                                                      ?.map(
                                                        (obj) => obj.optiontext
                                                      )
                                                      .join("/")}
                                                  />
                                                </div>
                                              )}
                                              {StudentTestPageCxt.showTranscript && (
                                                <div className="desc-admin-answer-div">
                                                  <div className="desc-admin-answer-label-div">
                                                    Transcript
                                                  </div>
                                                  <textarea
                                                    rows={5}
                                                    disabled={true}
                                                    id={
                                                      questionobj.id +
                                                      "showanswer"
                                                    }
                                                    key={
                                                      questionobj.id +
                                                      "showanswer"
                                                    }
                                                    className="desc-admin-answer"
                                                    name={
                                                      questionobj.id +
                                                      "" +
                                                      StudentTestPageCxt
                                                        .sectionObj.sectionid +
                                                      "showanswer"
                                                    }
                                                    value={
                                                      questionobj?.transcript
                                                    }
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          ) : (
                                            questionobj.options.map(
                                              (option, optindex) =>
                                                questionobj.libtypeid ===
                                                constants.libTypeIds
                                                  .MCQ_SINGLE ? (
                                                  <div
                                                    key={
                                                      option.optionid +
                                                      "" +
                                                      optindex +
                                                      StudentTestPageCxt.secIndex +
                                                      questionobj.libtypeid
                                                    }
                                                    className={
                                                      "commontest-mainpage-single-question-option-each-div"
                                                    }
                                                    onClick={
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .UNLOCKED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .REATTEMPT ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .QN_CONTINUE
                                                        ? () => {
                                                            StudentTestBodyPageSingleViewHks.collectAnswers(
                                                              questionobj.id,
                                                              option.optionid +
                                                                "",
                                                              questionobj.libtypeid,
                                                              StudentTestPageCxt.secIndex,
                                                              queindex,
                                                              0
                                                            );
                                                          }
                                                        : null
                                                    }
                                                    style={{
                                                      borderColor:
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status !==
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED
                                                          ? StudentTestBodyPageSingleViewHks.answers[
                                                              questionobj.id
                                                            ]?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                            ? "#F96343"
                                                            : (Alert.isAdmin ||
                                                                StudentTestPageCxt.isTrainer) &&
                                                              questionobj.answer?.includes(
                                                                option.optionid +
                                                                  ""
                                                              )
                                                            ? "#F96343"
                                                            : ""
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              1 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "#12B76A"
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              0 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "#F04438"
                                                          : "",
                                                      border:
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status !==
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED
                                                          ? StudentTestBodyPageSingleViewHks.answers[
                                                              questionobj.id
                                                            ]?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                            ? "2px solid #F96343"
                                                            : (Alert.isAdmin ||
                                                                StudentTestPageCxt.isTrainer) &&
                                                              questionobj.answer?.includes(
                                                                option.optionid +
                                                                  ""
                                                              )
                                                            ? "2px solid #F96343"
                                                            : ""
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              1 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "2px solid #12B76A"
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              0 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "2px solid #F04438"
                                                          : "",
                                                    }}
                                                  >
                                                    <div
                                                      className={
                                                        "commontest-mainpage-multiple-question-options-input-label-div"
                                                      }
                                                    >
                                                      <div
                                                        className={
                                                          "options-input-label-div"
                                                        }
                                                      >
                                                        <input
                                                          type="radio"
                                                          className="commontest-mainpage-multiple-question-options-input"
                                                          key={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          name={
                                                            questionobj.id +
                                                            "" +
                                                            StudentTestPageCxt
                                                              .sectionObj
                                                              .sectionid
                                                          }
                                                          id={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          value={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          onChange={() => {
                                                            StudentTestBodyPageSingleViewHks.collectAnswers(
                                                              questionobj.id,
                                                              option.optionid +
                                                                "",
                                                              questionobj.libtypeid,
                                                              StudentTestPageCxt.secIndex,
                                                              queindex,
                                                              0
                                                            );
                                                          }}
                                                          checked={
                                                            Alert
                                                              .mcqAndDesTestAndLpId
                                                              .status !==
                                                            constants
                                                              .PROGRESS_STATUS
                                                              .EVALUATED
                                                              ? StudentTestBodyPageSingleViewHks.answers[
                                                                  questionobj.id
                                                                ]?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                                ? true
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer) &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? true
                                                                : false
                                                              : option.iscorrectoption ===
                                                                  1 &&
                                                                questionobj.answer?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                              ? true
                                                              : option.iscorrectoption ===
                                                                  0 &&
                                                                questionobj.answer?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                              ? true
                                                              : false
                                                          }
                                                          style={{
                                                            accentColor:
                                                              Alert
                                                                .mcqAndDesTestAndLpId
                                                                .status !==
                                                              constants
                                                                .PROGRESS_STATUS
                                                                .EVALUATED
                                                                ? StudentTestBodyPageSingleViewHks.answers[
                                                                    questionobj
                                                                      .id
                                                                  ]?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                  ? "#F96343"
                                                                  : (Alert.isAdmin ||
                                                                      StudentTestPageCxt.isTrainer) &&
                                                                    questionobj.answer?.includes(
                                                                      option.optionid +
                                                                        ""
                                                                    )
                                                                  ? "#F96343"
                                                                  : ""
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer ||
                                                                    StudentTestPageCxt.viewTest ===
                                                                      constants
                                                                        .DISPLAY_TEST_RESULT
                                                                        .ALL) &&
                                                                  option.iscorrectoption ===
                                                                    1 &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? "green"
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer ||
                                                                    (StudentTestPageCxt.isLearner &&
                                                                      StudentTestPageCxt.viewTest ===
                                                                        constants
                                                                          .DISPLAY_TEST_RESULT
                                                                          .ALL)) &&
                                                                  option.iscorrectoption ===
                                                                    0 &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? "#F04438"
                                                                : "#F96343",
                                                          }}
                                                        />
                                                        <label className="commontest-mainpage-multiple-question-options-label">
                                                          {option.optiontext}
                                                        </label>
                                                      </div>
                                                      <div>
                                                        {(Alert.isAdmin ||
                                                          StudentTestPageCxt.isTrainer ||
                                                          (StudentTestPageCxt.isLearner &&
                                                            StudentTestPageCxt.viewTest ===
                                                              constants
                                                                .DISPLAY_TEST_RESULT
                                                                .ALL)) &&
                                                        option.iscorrectoption ===
                                                          1 ? (
                                                          <RightSvgIcon />
                                                        ) : (Alert.isAdmin ||
                                                            StudentTestPageCxt.isTrainer ||
                                                            (StudentTestPageCxt.isLearner &&
                                                              StudentTestPageCxt.viewTest ===
                                                                constants
                                                                  .DISPLAY_TEST_RESULT
                                                                  .ALL)) &&
                                                          option.iscorrectoption ===
                                                            0 &&
                                                          questionobj.answer?.includes(
                                                            option.optionid + ""
                                                          ) ? (
                                                          <WobackCloseSvg
                                                            stoke={"#F04438"}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : questionobj.libtypeid ===
                                                  constants.libTypeIds
                                                    .MCQ_MULTI ? (
                                                  <div
                                                    key={
                                                      option.optionid +
                                                      "" +
                                                      optindex +
                                                      StudentTestPageCxt.secIndex +
                                                      questionobj.libtypeid
                                                    }
                                                    className={
                                                      /* Alert.isAdmin ||
                                                      StudentTestPageCxt.viewTest ===
                                                        constants
                                                          .DISPLAY_TEST_RESULT
                                                          .ALL
                                                        ? "singleViewQuestionBoxDetailsOptionsDivEachOptionAdmin"
                                                        :  */ "commontest-mainpage-single-question-option-each-div"
                                                    }
                                                    onClick={
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .UNLOCKED ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .REATTEMPT ||
                                                      Alert.mcqAndDesTestAndLpId
                                                        .status ===
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .QN_CONTINUE
                                                        ? () => {
                                                            StudentTestBodyPageSingleViewHks.collectAnswers(
                                                              questionobj.id,
                                                              option.optionid +
                                                                "",
                                                              questionobj.libtypeid,
                                                              StudentTestPageCxt.secIndex,
                                                              queindex,
                                                              0
                                                            );
                                                          }
                                                        : null
                                                    }
                                                    style={{
                                                      borderColor:
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status !==
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED
                                                          ? StudentTestBodyPageSingleViewHks.answers[
                                                              questionobj.id
                                                            ]?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                            ? "#F96343"
                                                            : (Alert.isAdmin ||
                                                                StudentTestPageCxt.isTrainer) &&
                                                              questionobj.answer?.includes(
                                                                option.optionid +
                                                                  ""
                                                              )
                                                            ? "#F96343"
                                                            : ""
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              1 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "#12B76A"
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              0 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "#F04438"
                                                          : "",
                                                      border:
                                                        Alert
                                                          .mcqAndDesTestAndLpId
                                                          .status !==
                                                        constants
                                                          .PROGRESS_STATUS
                                                          .EVALUATED
                                                          ? StudentTestBodyPageSingleViewHks.answers[
                                                              questionobj.id
                                                            ]?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                            ? "2px solid #F96343"
                                                            : (Alert.isAdmin ||
                                                                StudentTestPageCxt.isTrainer) &&
                                                              questionobj.answer?.includes(
                                                                option.optionid +
                                                                  ""
                                                              )
                                                            ? "2px solid #F96343"
                                                            : ""
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              1 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "2px solid #12B76A"
                                                          : (Alert.isAdmin ||
                                                              StudentTestPageCxt.isTrainer ||
                                                              (StudentTestPageCxt.isLearner &&
                                                                StudentTestPageCxt.viewTest ===
                                                                  constants
                                                                    .DISPLAY_TEST_RESULT
                                                                    .ALL)) &&
                                                            option.iscorrectoption ===
                                                              0 &&
                                                            questionobj.answer?.includes(
                                                              option.optionid +
                                                                ""
                                                            )
                                                          ? "2px solid #F04438"
                                                          : "",
                                                    }}
                                                  >
                                                    <div
                                                      className={
                                                        "commontest-mainpage-multiple-question-options-input-label-div"
                                                      }
                                                    >
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="commontest-mainpage-multiple-question-options-input"
                                                          key={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          name={
                                                            questionobj.id +
                                                            "" +
                                                            StudentTestPageCxt
                                                              .sectionObj
                                                              .sectionid
                                                          }
                                                          id={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          value={
                                                            option.optionid +
                                                            "" +
                                                            optindex +
                                                            StudentTestPageCxt.secIndex +
                                                            questionobj.libtypeid
                                                          }
                                                          onChange={() => {
                                                            StudentTestBodyPageSingleViewHks.collectAnswers(
                                                              questionobj.id,
                                                              option.optionid +
                                                                "",
                                                              questionobj.libtypeid,
                                                              StudentTestPageCxt.secIndex,
                                                              queindex,
                                                              0
                                                            );
                                                          }}
                                                          checked={
                                                            Alert
                                                              .mcqAndDesTestAndLpId
                                                              .status !==
                                                            constants
                                                              .PROGRESS_STATUS
                                                              .EVALUATED
                                                              ? StudentTestBodyPageSingleViewHks.answers[
                                                                  questionobj.id
                                                                ]?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                                ? true
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer) &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? true
                                                                : false
                                                              : option.iscorrectoption ===
                                                                  1 &&
                                                                questionobj.answer?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                              ? true
                                                              : option.iscorrectoption ===
                                                                  0 &&
                                                                questionobj.answer?.includes(
                                                                  option.optionid +
                                                                    ""
                                                                )
                                                              ? true
                                                              : false
                                                          }
                                                          style={{
                                                            accentColor:
                                                              Alert
                                                                .mcqAndDesTestAndLpId
                                                                .status !==
                                                              constants
                                                                .PROGRESS_STATUS
                                                                .EVALUATED
                                                                ? StudentTestBodyPageSingleViewHks.answers[
                                                                    questionobj
                                                                      .id
                                                                  ]?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                  ? "#F96343"
                                                                  : (Alert.isAdmin ||
                                                                      StudentTestPageCxt.isTrainer) &&
                                                                    questionobj.answer?.includes(
                                                                      option.optionid +
                                                                        ""
                                                                    )
                                                                  ? "#F96343"
                                                                  : ""
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer ||
                                                                    (StudentTestPageCxt.isLearner &&
                                                                      StudentTestPageCxt.viewTest ===
                                                                        constants
                                                                          .DISPLAY_TEST_RESULT
                                                                          .ALL)) &&
                                                                  option.iscorrectoption ===
                                                                    1 &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? "green"
                                                                : (Alert.isAdmin ||
                                                                    StudentTestPageCxt.isTrainer ||
                                                                    (StudentTestPageCxt.isLearner &&
                                                                      StudentTestPageCxt.viewTest ===
                                                                        constants
                                                                          .DISPLAY_TEST_RESULT
                                                                          .ALL)) &&
                                                                  option.iscorrectoption ===
                                                                    0 &&
                                                                  questionobj.answer?.includes(
                                                                    option.optionid +
                                                                      ""
                                                                  )
                                                                ? "#F04438"
                                                                : "#F96343",
                                                          }}
                                                        />
                                                        <label className="commontest-mainpage-multiple-question-options-label">
                                                          {option.optiontext}
                                                        </label>
                                                      </div>

                                                      <div>
                                                        {(Alert.isAdmin ||
                                                          StudentTestPageCxt.isTrainer ||
                                                          (StudentTestPageCxt.isLearner &&
                                                            StudentTestPageCxt.viewTest ===
                                                              constants
                                                                .DISPLAY_TEST_RESULT
                                                                .ALL)) &&
                                                        option.iscorrectoption ===
                                                          1 ? (
                                                          <RightSvgIcon />
                                                        ) : (Alert.isAdmin ||
                                                            StudentTestPageCxt.isTrainer ||
                                                            (StudentTestPageCxt.isLearner &&
                                                              StudentTestPageCxt.viewTest ===
                                                                constants
                                                                  .DISPLAY_TEST_RESULT
                                                                  .ALL)) &&
                                                          option.iscorrectoption ===
                                                            0 &&
                                                          questionobj.answer?.includes(
                                                            option.optionid + ""
                                                          ) ? (
                                                          <WobackCloseSvg
                                                            stoke={"#F04438"}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  ""
                                                )
                                            )
                                          )}
                                        </div>
                                      </div>
                                      {Alert.isAdmin &&
                                        (Alert.mcqAndDesTestAndLpId.status ===
                                          constants.PROGRESS_STATUS.EVALUATED ||
                                          Alert.mcqAndDesTestAndLpId.status ===
                                            constants.PROGRESS_STATUS
                                              .TO_BE_EVALUATED ||
                                          Alert.mcqAndDesTestAndLpId.status ===
                                            constants.PROGRESS_STATUS
                                              .PARTIAL_EVALUATED) &&
                                        (Alert.backupTestData.sections[0]
                                          .questions[0]?.libtypeid ===
                                          constants.libTypeIds.SAQ ||
                                          Alert.backupTestData.sections[0]
                                            .questions[0]?.libtypeid ===
                                            constants.libTypeIds.LAQ ||
                                            +Alert.backupTestData.sections[0]
                                            .questions[0]?.libtypeid ===
                                            constants.libTypeIds.CODING_SNIPPET) && (
                                          <div className="admin-Marks-Input-Div">
                                            <div className="admin-Marks-Input-DivItems">
                                              <div
                                                key={questionobj.id}
                                                className="admin-Marks-Input"
                                              >
                                                <input
                                                  min="0"
                                                  className="saq-Laq-Marks-Entry"
                                                  max={
                                                    questionobj.targetscore + ""
                                                  }
                                                  placeholder={
                                                    questionobj.hasOwnProperty(
                                                      "actualscore"
                                                    )
                                                      ? questionobj.actualscore
                                                      : ""
                                                  }
                                                  value={
                                                    Alert.descScores.hasOwnProperty(
                                                      questionobj.id
                                                    ) &&
                                                    Alert.descScores[
                                                      questionobj.id
                                                    ] != null
                                                      ? Alert.descScores[
                                                          questionobj.id
                                                        ]
                                                      : questionobj.hasOwnProperty(
                                                          "actualscore"
                                                        ) &&
                                                        questionobj.actualscore !=
                                                          null
                                                      ? questionobj.actualscore
                                                      : ""
                                                  }
                                                  style={{
                                                    borderColor:
                                                      StudentTestPageCxt.scoreErrors.hasOwnProperty(
                                                        questionobj.id
                                                      )
                                                        ? "red"
                                                        : "black",
                                                  }}
                                                  onChange={(e) => {
                                                    StudentTestBodyPageHks.collectScores(
                                                      questionobj.id,
                                                      e.target.value,
                                                      questionobj.targetscore,
                                                      e
                                                    );
                                                  }}
                                                  onKeyDown={(e) => {
                                                    StudentTestPageHks.handleScoreKeyDown(
                                                      e
                                                    );
                                                  }}
                                                  onWheel={(e) =>
                                                    e.target.blur()
                                                  }
                                                />

                                                <div className="approveScoreDivTotalMarks">
                                                  /{" "}
                                                  {questionobj.targetscore +
                                                    " Marks"}
                                                </div>
                                              </div>

                                              {Alert.isAdmin && (
                                                <div>
                                                  <Box sx={{ width: 250 }}>
                                                    <PrettoSlider
                                                      valueLabelDisplay="auto"
                                                      aria-label="pretto slider"
                                                      step={0.5}
                                                      value={
                                                        Alert.descScores.hasOwnProperty(
                                                          questionobj.id
                                                        )
                                                          ? Alert.descScores[
                                                              questionobj.id
                                                            ]
                                                          : questionobj.hasOwnProperty(
                                                              "actualscore"
                                                            ) &&
                                                            questionobj.actualscore ==
                                                              null
                                                          ? ""
                                                          : questionobj.actualscore
                                                      }
                                                      onChange={(e) => {
                                                        StudentTestBodyPageHks.collectScores(
                                                          questionobj.id,
                                                          e.target.value,
                                                          questionobj.targetscore,
                                                          e
                                                        );
                                                      }}
                                                      disabled={
                                                        StudentTestPageCxt.giveZeros &&
                                                        (questionobj.answer ===
                                                          "" ||
                                                          questionobj.answer ==
                                                            null)
                                                      }
                                                      max={
                                                        questionobj.targetscore
                                                      }
                                                    />
                                                  </Box>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                    </>
                                  </div>
                                  <div className="commontest-mainpage-single-multiple-question-answer-score-div">
                                    {StudentTestPageCxt.showSaqLaqAns &&
                                      (questionobj.libtypeid ===
                                        constants.libTypeIds.MCQ_SINGLE ||
                                        questionobj.libtypeid ===
                                          constants.libTypeIds.MCQ_MULTI) && (
                                        <div className="mcq-admin-answer-div">
                                          <div className="mcq-admin-answer-label-div">
                                            Explanation
                                          </div>

                                          <Editor
                                            toolbar=""
                                            disabled={true}
                                            menubar={false}
                                            branding={false}
                                            statusbar={false}
                                            className="mcq-admin-answer"
                                            tinymceScriptSrc="/tinymce/tinymce.min.js"
                                            value={
                                              questionobj?.answerexplanation
                                            }
                                            onInit={(evt, editor) =>
                                              (StudentTestPageCxt.editorRef.current =
                                                editor)
                                            }
                                            init={{
                                              resize: false,
                                              readonly: true,
                                              menubar: false,
                                              statusbar: false,
                                              license_key: "gpl",
                                              plugins: "autoresize",
                                            }}
                                          />
                                        </div>
                                      )}
                                    <div className="commontest-mainpage-single-multiple-question-divider-div"></div>
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                          ))}
                        </div>
                      }
                    </>
                  )}
              </div>
            </div>
          )}
        </div>

        {/* {(Alert.isLoaded ) ? <Loading /> : null} */}
      </div>
    </>
  );
}
